/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M0.516,22.5 L23.5,22.5" />
      <rect x="5.516" y="5.5" width="13" height="17" />
      <rect x="8.516" y="3.5" width="7" height="2" />
      <path d="M17.516,2.5 C17.516,-0.167 6.516,-0.167 6.516,2.5 L6.516,5.5 L17.516,5.5 L17.516,2.5 Z" />
      <rect x="7.516" y="8.5" width="9" height="14" />
      <path d="M7.516,11.5 L16.516,11.5" />
      <path d="M7.516,14.5 L16.516,14.5" />
      <path d="M7.516,17.5 L16.516,17.5" />
      <path d="M10.516,8.5 L10.516,17.5" />
      <path d="M13.516,8.5 L13.516,17.5" />
    </g>
  </svg>
);

export default Icon;
